@if (!loading) {
  <div>
    @if (captures.length > 0) {
      <table class="table m-0">
        <thead>
          <tr>
            <th>CLAIM ID</th>
            <th>STATUS</th>
            <th class="text-end text-nowrap">SERVICE DATE &#x25BC;</th>
          </tr>
        </thead>
        <tbody>
          @for (capture of captures; track capture) {
            <tr>
              <td class="text-nowrap">
                <a routerLink="/capture-admin/captures/{{capture.id}}" target="_blank">{{
                  capture.candidate.claimIdentifier
                }}</a>
              </td>
              <td>{{ capture.status | captureStatus }}</td>
              <td class="text-end">{{ capture.candidate.serviceDate | date: 'MM/dd/yyyy' }}</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <p>There are no captures for this fax.</p>
    }
  </div>
} @else {
  <div><mat-spinner diameter="30" /></div>
}
